export var Icons;
(function (Icons) {
    Icons["STAR_0"] = "star-0";
    Icons["STAR_0_5"] = "star-0-5";
    Icons["STAR_1"] = "star-1";
    Icons["STAR_1_5"] = "star-1-5";
    Icons["STAR_2"] = "star-2";
    Icons["STAR_2_5"] = "star-2-5";
    Icons["STAR_3"] = "star-3";
    Icons["STAR_3_5"] = "star-3-5";
    Icons["STAR_4"] = "star-4";
    Icons["STAR_4_5"] = "star-4-5";
    Icons["STAR_5"] = "star-5";
    Icons["AQUARIUMS"] = "aquariums";
    Icons["AQUARIUM"] = "aquarium";
    Icons["PRICE"] = "price";
    Icons["TROPHY"] = "trophy";
    Icons["AWARD"] = "award";
    Icons["BARBEQUE"] = "barbeque";
    Icons["BBQ"] = "bbq";
    Icons["CAR_SPEED"] = "car-speed";
    Icons["CART"] = "cart";
    Icons["CART_SPEED"] = "cart-speed";
    Icons["CART_STACKED"] = "cart-stacked";
    Icons["CH_DOWN"] = "ch-down";
    Icons["CH_LEFT"] = "ch-left";
    Icons["CH_RIGHT"] = "ch-right";
    Icons["CH_UP"] = "ch-up";
    Icons["CIRCLE"] = "circle";
    Icons["CIRCLE_EMPTY"] = "circle-empty";
    Icons["CIRCLE_FULL"] = "circle-full";
    Icons["COOLING"] = "cooling";
    Icons["CROSS"] = "cross";
    Icons["CROSS_BOX"] = "cross-box";
    Icons["CROSS_BOX_FULL"] = "cross-box-full";
    Icons["FILE"] = "file";
    Icons["DOCUMENT"] = "document";
    Icons["DOWNLOAD"] = "download";
    Icons["EURO"] = "euro";
    Icons["EXPERT"] = "expert";
    Icons["GIFT"] = "gift";
    Icons["HEART"] = "heart";
    Icons["HEART_FULL"] = "heart-full";
    Icons["HEATING"] = "heating";
    Icons["SPAS"] = "spas";
    Icons["HOTTUB"] = "hottub";
    Icons["INFO_BOX"] = "info-box";
    Icons["INFO_BOX_FULL"] = "info-box-full";
    Icons["INSTAGRAM"] = "instagram";
    Icons["LIGHT"] = "light";
    Icons["LIGHT_FULL"] = "light-full";
    Icons["MAIL"] = "mail";
    Icons["MEGAPHONE"] = "megaphone";
    Icons["BLACKFRIDAY"] = "blackfriday";
    Icons["SALE"] = "sale";
    Icons["BOX_MIN"] = "box-min";
    Icons["MIN_BOX"] = "min-box";
    Icons["CON"] = "con";
    Icons["BOX_MIN_FULL"] = "box-min-full";
    Icons["MIN_BOX_FULL"] = "min-box-full";
    Icons["MINUS"] = "minus";
    Icons["LUCHTBED"] = "luchtbed";
    Icons["OUTDOOR"] = "outdoor";
    Icons["PENCIL"] = "pencil";
    Icons["PEN"] = "pen";
    Icons["PLUS"] = "plus";
    Icons["RETURN"] = "return";
    Icons["QUESTION_CIRCLE_FULL"] = "question-circle-full";
    Icons["QUESTION_BOX_FULL"] = "question-box-full";
    Icons["QUESTION_CIRCLE"] = "question-circle";
    Icons["QUESTION_BOX"] = "question-box";
    Icons["BOX_QUESTION"] = "box-question";
    Icons["SEARCH"] = "search";
    Icons["SETTINGS"] = "settings";
    Icons["STAR_EMPTY"] = "star-empty";
    Icons["STAR"] = "star";
    Icons["STAR_FULL"] = "star-full";
    Icons["STAR_HALF"] = "star-half";
    Icons["TALK"] = "talk";
    Icons["TIMER"] = "timer";
    Icons["TREE"] = "tree";
    Icons["COMMENT_O"] = "comment-o";
    Icons["COMMENT"] = "comment";
    Icons["CHECKLIST"] = "checklist";
    Icons["CAPACITY"] = "capacity";
    Icons["TELEPHONE"] = "telephone";
    Icons["THUMBS_DOWN"] = "thumbs-down";
    Icons["THUMBS_DOWN_FULL"] = "thumbs-down-full";
    Icons["THUMBS_UP"] = "thumbs-up";
    Icons["THUMBS_UP_FULL"] = "thumbs-up-full";
    Icons["TOPPY_BOX"] = "toppy-box";
    Icons["TOPPY_BOX_SPEED"] = "toppy-box-speed";
    Icons["TOPPY_BOX_BACK"] = "toppy-box-back";
    Icons["TOPPY_ICON"] = "toppy-icon";
    Icons["TRASH"] = "trash";
    Icons["SCHOP"] = "schop";
    Icons["TUIN"] = "tuin";
    Icons["TWITTER"] = "twitter";
    Icons["WATERSPORT"] = "watersport";
    Icons["WHATSAPP"] = "whatsapp";
    Icons["YOUTUBE"] = "youtube";
    Icons["ZWEMBAD"] = "zwembad";
    Icons["CHAT"] = "chat";
    Icons["CHECK"] = "check";
    Icons["CHECK_BOX"] = "check-box";
    Icons["CHECK_BOX_FULL"] = "check-box-full";
    Icons["VIJVERS"] = "vijvers";
    Icons["VIJVER"] = "vijver";
    Icons["FACEBOOK"] = "facebook";
    Icons["FILTER"] = "filter";
    Icons["SLIDERS"] = "sliders";
    Icons["GARDEN"] = "garden";
    Icons["GRID"] = "grid";
    Icons["HAMBURGER"] = "hamburger";
    Icons["MENU"] = "menu";
    Icons["LINK"] = "link";
    Icons["LINKEDIN"] = "linkedin";
    Icons["LIST"] = "list";
    Icons["LOADING"] = "loading";
    Icons["LOCATION"] = "location";
    Icons["PIN"] = "pin";
    Icons["BOX_PLUS"] = "box-plus";
    Icons["PLUS_BOX"] = "plus-box";
    Icons["PRO"] = "pro";
    Icons["BOX_PLUS_FULL"] = "box-plus-full";
    Icons["PLUS_BOX_FULL"] = "plus-box-full";
    Icons["ACCOUNT"] = "account";
    Icons["PROFILE"] = "profile";
    Icons["ACCOUNT_FULL"] = "account-full";
    Icons["PROFILE_FULL"] = "profile-full";
    Icons["CAR"] = "car";
    Icons["KAMPEREN"] = "kamperen";
    Icons["TIPI"] = "tipi";
    Icons["SNOEIEN"] = "snoeien";
    Icons["SPORT"] = "sport";
    Icons["SPEL"] = "spel";
    Icons["TENT"] = "tent";
    Icons["BOX"] = "box";
    Icons["BOX_FULL"] = "box-full";
})(Icons || (Icons = {}));
export var IconSizes;
(function (IconSizes) {
    IconSizes["XXS"] = "xxs";
    IconSizes["XS"] = "xs";
    IconSizes["S"] = "s";
    IconSizes["M"] = "m";
    IconSizes["L"] = "l";
    IconSizes["XL"] = "xl";
    IconSizes["XXL"] = "xxl";
    IconSizes["JUMBO"] = "jumbo";
})(IconSizes || (IconSizes = {}));
